import React, { useContext } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, makeStyles } from '@material-ui/core';
// import BACK_ARROW from '../../../assets/images/arrow-left.png';
import { PropTypes } from 'prop-types';
import { Stepper } from '../index';
import LanguageContext from '../../../contexts/languageContext';
import { CrossIcon } from '../Images/Icons';
const styles = makeStyles({
    paperFullScreen: {
        width: 'calc(100% - 23px)',
        height: 'calc(100% - 105px)',
        marginTop: '81px',
        marginBottom: '24px',
        borderRadius: '10px',
        direction: (props) => (props.rtl ? 'rtl' : 'ltr')
    },
    dialog: (props) => ({
        direction: props.rtl ? 'rtl' : 'ltr',
        fontFamily: 'mainFont',
        textAlign: props.rtl ? 'right' : 'left',
        minWidth: props.minWidth ? props.minWidth + 'px' : '400px',
        minHeight: props.minHeight ? props.minHeight + 'px' : '400px',
        maxHeight: '100vh',
        maxWidth: props.maxWidth && props.maxWidth + 'px',
        margin: '0 auto'
    }),
    titleRoot: {
        textAlign: 'center',
        // boxShadow: '0 2px 24px 0 rgba(0, 0, 0, 0.06)',
        position: 'relative',
        paddingRight: '50px',
        '& > *': {
            fontSize: '14px'
        }
    },
    title: {
        fontSize: '16px',
        fontWeight: 'bold',
        textAlign: 'right',
        marginTop: '20px'
    },
    backContainer: {
        position: 'absolute',
        right: '20px',
        top: '18px',
        display: 'flex',
        flexFlow: 'row-reverse',
        justifyContent: 'center',
        '& svg': {
            width: '13px',
            height: '13px'
            // margin: '0 18px 0 14px'
        },
        '& *': {
            cursor: 'pointer'
        }
    },
    dialogContent: {
        padding: ({ padding }) => (padding ? padding : '0 24px 8px 24px'),
        overflowX: 'hidden'
    }
});
export default function MainDialog(props) {
    const { lang } = useContext(LanguageContext);
    const classes = styles({ ...props, rtl: lang === 'fa' });
    const { stepper, title, open } = props;
    return (
        <Dialog
            fullWidth={props.fullScreen ? true : false}
            maxWidth={'md'}
            scroll={'paper'}
            open={open}
            classes={
                props.fullScreen
                    ? { paperFullScreen: classes.paperFullScreen, container: classes.dialog }
                    : { paper: classes.dialog, container: classes.dialog }
            }
            onClose={props.goBack}
            data-testid="mainDialog"
        >
            <DialogTitle classes={{ root: classes.titleRoot }}>
                <div>
                    <div className={classes.title}>{title}</div>
                    {stepper && (
                        <Stepper
                            stepperItems={stepper.items}
                            activeStep={stepper.activeStep}
                            handleClick={(e) => props.handleNavigation(e)}
                        />
                    )}
                    <div
                        className={classes.backContainer}
                        onClick={props.goBack}
                        data-testid={'close'}
                    >
                        <CrossIcon width="15" height="15" />
                    </div>
                </div>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>{props.children}</DialogContent>
            {props.actions && <DialogActions>{props.actions}</DialogActions>}
        </Dialog>
    );
}
MainDialog.propTypes = {
    title: PropTypes.string,
    goBack: PropTypes.func.isRequired,
    children: PropTypes.object.isRequired,
    actions: PropTypes.any,
    fullScreen: PropTypes.bool,
    stepper: PropTypes.object,
    handleNavigation: PropTypes.func,
    open: PropTypes.bool,
    padding: PropTypes.string,
    maxWidth: PropTypes.string
};
